var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableEyeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 20.603 12.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a2b7df",
    d: "M10.314 6.717a11.2 11.2 0 0 1 8.159 3.98c-1.2 1.577-4.046 4.6-8.159 4.6-3.794 0-6.808-3.036-8.136-4.642a11.311 11.311 0 0 1 8.136-3.943zm0-1.717C3.817 5 0 10.624 0 10.624s4.151 6.395 10.314 6.395c6.638 0 10.289-6.395 10.289-6.395S16.919 5 10.314 5zM10.3 7.575a3.434 3.434 0 1 0 3.434 3.434A3.435 3.435 0 0 0 10.3 7.575z",
    transform: "translate(0 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableEyeIcon);
export default __webpack_public_path__ + "static/media/TableEyeIcon.d08f18bcfe2dff991dd52f2d985f5e49.svg";
export { ForwardRef as ReactComponent };